var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"grpTable",attrs:{"index":"","paging":false,"excel":_vm.isButton_(_vm.scrId, 'EX'),"columns":_vm.cols,"rows":_vm.rows,"stripe":false,"selection":false,"span-method":_vm.spanMethod}})
}
var staticRenderFns = []

export { render, staticRenderFns }